export const pagesMutations = {
  setPagesFormStatus(state, payload) {
    state.pagesFormStatus = payload;
  },
  setPagesIsEdit(state, payload) {
    state.pagesIsEdit = payload
  },
  setPagesSelectedForEdit(state, payload) {
    state.pagesSelectedForEdit = payload
  },
  setPagePublishRequest(state, payload) {
    state.pagePublishRequest = payload
  },
  
};